module.exports = __webpack_public_path__ + "imgs/cbd-stores.e1a5b767f2f5736009bf5b6a0292cb60.svg";